import * as React from "react";
import {ICoverCheckerPortalService} from "../services/ICoverCheckerPortalService";
import {VEHICLE_REG_NUMBER_REGEX} from "../Constants";
import {Types} from "../Types";
import {lazyInject} from "@athena-portal/core";
import '../theme/_cover-checker-page.scss';
import CoverDetails from "../model/CoverDetails";

interface IState {
    vinNumber: string;
    startDate: string;
    endDate: string;
    isVinValid: boolean;
    errorResponse: string;
}

export class CoverCheckerPage extends React.Component<{}, IState> {

    @lazyInject(Types.CoverCheckerPortalService)
    private coverCheckerService: ICoverCheckerPortalService;

    constructor(props: {}) {
        super(props);
        this.state = {
            vinNumber: "",
            startDate: "",
            endDate: "",
            isVinValid: false,
            errorResponse: ""
        }
    }

    public render(): React.ReactNode {

        return (
            <div className="cover-checker-container">
                <div className="cover-page-header">
                    <h1>Drive Away Insurance</h1>
                    <h5>Please enter the vehicle registration</h5>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <input
                        type="text"
                        value={this.state.vinNumber}
                        maxLength={8}
                        onChange={this.handleInput}
                        className="registration-input"
                        required={true}
                    />
                    <button type="submit" className="find-button">Find vehicle</button>
                </form>
                {this.state.errorResponse && (
                    <div className="error-message-display">
                        <strong>{this.state.errorResponse}</strong>
                        <button type="button" className="close-button" onClick={() => this.setState({
                            errorResponse: "",
                            isVinValid: false,
                            vinNumber: "",
                            startDate: ""
                        })}
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                {this.state.isVinValid && this.state.startDate && (
                    <div className="result-display">
                        <h3>Result for: {this.state.vinNumber}</h3>
                        <p>Cover start date: {this.state.startDate}</p>
                        <p>Cover end date: {this.state.endDate}</p>
                    </div>
                )}
            </div>
        );
    }

    private handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const value = e.target.value.toUpperCase();
        this.setState({
            vinNumber: value,
            isVinValid: false,
            errorResponse: "",
            startDate: ""
        })
    }

    private formatDate = (date: Date): string => {

        const dateArr: string[] = date.toString().split("-");
        const dayTime: string[] = dateArr[2].split("T");
        const zoneTime: string[] = dayTime[1].split(".");

        const time = zoneTime[0]
        const day = dayTime[0];
        const month = dateArr[1];
        const year = dateArr[0];
        return `${day} ${month} ${year} : ${time}`;
    };

    private removeSpaces = (input: string): string => {
        return input.replace(/\s+/g, "");
    }

    private handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const vinNumber = this.removeSpaces(this.state.vinNumber);
        if (VEHICLE_REG_NUMBER_REGEX.test(vinNumber)) {
            this.coverCheckerService.getCoverDetailsByVin(vinNumber).subscribe(
                (coverResponse: CoverDetails) => {
                    if (!coverResponse.policyStartDate) {
                        this.setState({
                            errorResponse: "Sorry record not found",
                            isVinValid: false,
                            vinNumber: ""
                        });
                    } else {
                        this.setState({
                            isVinValid: true,
                            startDate: this.formatDate(coverResponse.policyStartDate),
                            endDate: this.formatDate(coverResponse.policyEndDate),
                            errorResponse: ""
                        })
                    }
                })
        } else {
            this.setState({
                errorResponse: "Please enter valid registration number",
                isVinValid: false,
                vinNumber: ""
            })
        }
    }
}
